import { getGlobalProject } from "src/utils/globals";
import { createController, createControllerFileEndpoint } from "src/utils/api";
import { JobFileUploadResult } from "src/data/types/files/types";

const project = getGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/files/' + project.UniqueCode, {
    jobsShort: createControllerFileEndpoint<JobFileUploadResult>('POST', '/jobs/short')
});
